var _defs, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #091430;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: -7.3,
    y: 31.2,
    width: 89.8,
    height: 12.7,
    transform: "translate(-15.5 37.6) rotate(-45)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 31.2,
    y: -7.5,
    width: 12.7,
    height: 89.8,
    transform: "translate(-15.5 37.5) rotate(-45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3a6e8fc8f06d94b2560ef0deb32a1ffe.svg";
export { ForwardRef as ReactComponent };